var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trial global-page-base-layout" },
    [
      _c("div", { staticClass: "select-conditions" }, [
        _c(
          "div",
          { staticClass: "select-conditions-row" },
          [
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple" },
                [
                  _vm._v("\n          模板名称：\n          "),
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "标题" },
                    model: {
                      value: _vm.titlevalue,
                      callback: function ($$v) {
                        _vm.titlevalue = $$v
                      },
                      expression: "titlevalue",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple-light" },
                [
                  _vm._v("\n          状  态：\n          "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { size: "medium", placeholder: "请选择状态" },
                      model: {
                        value: _vm.statevalue,
                        callback: function ($$v) {
                          _vm.statevalue = $$v
                        },
                        expression: "statevalue",
                      },
                    },
                    _vm._l(_vm.stateArr, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 6 } }, [
              _c(
                "div",
                { staticClass: "select-conditions-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("\n            筛选\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "clear-all",
                      on: { click: _vm.clearAllConditon },
                    },
                    [_vm._v("清空筛选条件")]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleThisCreate } },
            [_vm._v("\n      添加音频公告\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                height: "calc(100vh - 360px)",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "title", label: "标题" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "更新时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sortNo", label: "排序号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.state == 1 ? "已启用" : "已禁用") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleThisUpdate(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "audio-notice-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            top: "10vh",
            "close-on-click-modal": false,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              { staticClass: "form-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("基本信息")]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-position": "right",
                      "label-width": "80px",
                      rules: _vm.formRules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "title" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            placeholder: "请输入音频公告标题",
                            maxlength: "50",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态", prop: "state" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "state", $$v)
                              },
                              expression: "form.state",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: 1, border: "" } },
                              [_vm._v("启用")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              { attrs: { label: 0, border: "" } },
                              [_vm._v("禁用")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "audio-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-headset" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("音频文件")]),
                ]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticClass: "upload-demo",
                    attrs: {
                      action: _vm.uploadUrl,
                      multiple: false,
                      "file-list": _vm.fileList,
                      accept: "audio/mp3, audio/wav, audio/ogg",
                      "on-success": _vm.handleUploadSuccess,
                      "on-change": _vm.handleUploadChange,
                      "on-remove": _vm.handleUploadRemove,
                      headers: _vm.headers,
                      drag: "",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v("\n            将音频文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip",
                      },
                      [
                        _vm._v(
                          "\n            只能上传 mp3/wav/ogg 格式，且不超过 50M\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.form.audioPath != ""
                  ? _c("div", { staticClass: "audio-preview" }, [
                      _c("div", { staticClass: "preview-title" }, [
                        _c("i", { staticClass: "el-icon-video-play" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("音频预览")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "audio-player" }, [
                        _c(
                          "audio",
                          { attrs: { id: "audio-path", controls: "" } },
                          [
                            _c("source", {
                              attrs: {
                                src: _vm.form.audioHref,
                                type: "audio/mpeg",
                              },
                            }),
                            _vm._v(
                              "\n              您的浏览器不支持在线播放音乐。\n            "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-check" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmit("form")
                    },
                  },
                },
                [_vm._v("\n        确 定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }